import { createAction } from '@reduxjs/toolkit';

export const requestUpdateId = createAction('request/updateId');
export const requestUpdateUID = createAction('request/updateUid');
export const requestUpdateSID = createAction('request/updateSid');
export const requestUpdateIsAdded = createAction('request/updateIsAdded');
export const requestUpdateIsActive = createAction('request/updateIsActive');

export const requestStore = createAction('request/store');
export const requestClear = createAction('request/clear');

export const requestUpdateRequesting = createAction('request/updateRequesting');
export const requestUpdateRequest = createAction('request/updateRequest');
export const requestUpdateError = createAction('request/updateError');
export const requestUpdateStore = createAction('request/updateStore');

export const requestUpdateItems = createAction('request/updateItems');
export const requestUpdateViewType = createAction('request/updateViewType');

export const requestUpdateHeadingTitle = createAction('request/updateHeadingTitle');
export const requestUpdateHeadingDescription = createAction('request/updateHeadingDescription');
export const requestUpdateHeadingTextAlign = createAction('request/updateHeadingTextAlign');
export const requestUpdateHeadingImage = createAction('request/updateHeadingImage');
export const requestUpdateHeadingDivider = createAction('request/updateHeadingDivider');

export const requestUpdateSectionIsBackground = createAction('request/updateSectionIsBackground');
export const requestUpdateSectionTextColor = createAction('request/updateSectionTextColor');
export const requestUpdateSectionBackgroundColor = createAction('request/updateSectionBackgroundColor');
export const requestUpdateSectionOpacity = createAction('request/updateSectionOpacity');
export const requestUpdateSectionIsFullWidth = createAction('request/updateSectionIsFullWidth');
export const requestUpdateSectionShadow = createAction('request/updateSectionShadow');
export const requestUpdateSectionShadowColor = createAction('request/updateSectionShadowColor');
export const requestUpdateSectionPadding = createAction('request/updateSectionPadding');
export const requestUpdateSectionMargin = createAction('request/updateSectionMargin');
export const requestUpdateSectionBackgroundType = createAction('request/updateSectionBackgroundType');
export const requestUpdateSectionBackgroundImage = createAction('request/updateSectionBackgroundImage');
export const requestUpdateSectionGradientColor1 = createAction('request/updateSectionGradientColor1');
export const requestUpdateSectionGradientColor2 = createAction('request/updateSectionGradientColor2');
export const requestUpdateSectionGradientDirection = createAction('request/updateSectionGradientDirection');
export const requestUpdateSectionGradientOffset = createAction('request/updateSectionGradientOffset');
export const requestUpdateSectionBorder = createAction('request/updateSectionBorder');
export const requestUpdateSectionBorderColor = createAction('request/updateSectionBorderColor');
export const requestUpdateSectionShadowBorderColor = createAction('request/updateSectionShadowBorderColor');
export const requestUpdateSectionShape = createAction('request/updateSectionShape');

export const requestUpdateItemOpacity = createAction('request/updateItemOpacity');
export const requestUpdateItemShadow = createAction('request/updateItemShadow');
export const requestUpdateItemShadowColor = createAction('request/updateItemShadowColor');
export const requestUpdateItemBorder = createAction('request/updateItemBorder');
export const requestUpdateItemBorderColor = createAction('request/updateItemBorderColor');
export const requestUpdateItemShape = createAction('request/updateItemShape');

export const requestUpdateButtonText = createAction('request/updateButtonText');
export const requestUpdateButtonBackgroundColor = createAction('request/updateButtonBackgroundColor');
export const requestUpdateButtonTextColor = createAction('request/updateButtonTextColor');
export const requestUpdateButtonOpacity = createAction('request/updateButtonOpacity');
export const requestUpdateButtonBorder = createAction('request/updateButtonBorder');
export const requestUpdateButtonBorderColor = createAction('request/updateButtonBorderColor');
export const requestUpdateButtonShadow = createAction('request/updateButtonShadow');
export const requestUpdateButtonShadowColor = createAction('request/updateButtonShadowColor');
export const requestUpdateButtonShape = createAction('request/updateButtonShape');
